import React, { useMemo } from "react";

/**
 * Decorative floating petals, pure CSS, respects prefers-reduced-motion.
 * Kept behind content (pointer-events-none, low opacity).
 */
export default function FloatingPetals({ count = 10, className = "" }) {
  const petals = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 10,
        duration: 14 + Math.random() * 12,
        size: 14 + Math.random() * 20,
        rotate: Math.random() * 360,
        opacity: 0.35 + Math.random() * 0.35,
      })),
    [count]
  );

  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    >
      {petals.map((p) => (
        <svg
          key={p.id}
          className="petal-drift absolute -top-10"
          style={{
            left: `${p.left}%`,
            width: p.size,
            height: p.size,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            opacity: p.opacity,
            transform: `rotate(${p.rotate}deg)`,
          }}
          viewBox="0 0 32 32"
        >
          <path
            d="M16 2 C22 8 28 12 26 22 C24 30 8 30 6 22 C4 12 10 8 16 2 Z"
            fill="hsl(340, 80%, 82%)"
          />
          <path
            d="M16 6 C20 10 24 14 22 20 C20 26 12 26 10 20 C8 14 12 10 16 6 Z"
            fill="hsl(340, 75%, 90%)"
            opacity="0.7"
          />
        </svg>
      ))}
    </div>
  );
}
